import React from 'react';
import { TooltipProps } from '@mui/material';
import Tooltip from './Tooltip';

type ConditionalTooltipProps = {
  active?: boolean;
} & TooltipProps;

const ConditionalTooltip = ({ active, children, ...rest }: ConditionalTooltipProps) => {
  if (active) {
    return <Tooltip {...rest}>{children}</Tooltip>;
  }

  return children;
};

export default ConditionalTooltip;
